import { memo } from 'react';

import { isNullish } from 'remeda';

import FormControl, { FormControlProps } from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import MUISelect from '@mui/material/Select';

import { SelectOption } from 'v2/types';

interface SelectProps<T> {
  value?: T;
  options: SelectOption<T>[];
  label: string;
  required?: boolean;
  size?: FormControlProps['size'];
  onChange: (value: T) => void;
  disabled?: boolean;
}

const _Select = <T extends string | number>({
  value,
  options,
  label,
  onChange,
  size,
  required,
  disabled,
}: SelectProps<T>) => (
  <FormControl fullWidth required={required} size={size} disabled={disabled}>
    <InputLabel>{label}</InputLabel>

    <MUISelect value={isNullish(value) ? '' : value} label={label} onChange={(e) => onChange(e.target.value as T)}>
      {options.map((option) => (
        <MenuItem key={option.id} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </MUISelect>
  </FormControl>
);

export const Select = memo(_Select) as typeof _Select;
